var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('payment-no-auth-form')],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('help-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }